export const ELEMENT_CLOSURE_REGEX = /<\/\w+>/g;
export const ELEMENT_OPENING_REGEX = /<\w+>/g;
export const START_TEXT_BANK_TRANSFER = '<STMTTRN>';
export const END_TEXT_BANK_TRANSFER = '</STMTTRN>';
